import { alertLevel, type AlertLevel } from './alert-rules';
import { toDayFacts, type DayFacts } from './day-facts';
import { CallExtractionSchema, type CallExtraction } from './extraction';
import { parentSpeech, type Transcript } from './transcript';
import { triageMentions, type DroppedMention } from './triage';

export type Assessment =
  | {
      readonly ok: true;
      readonly level: AlertLevel;
      readonly facts: DayFacts;
      readonly extraction: CallExtraction;
      readonly dropped: readonly DroppedMention[];
    }
  | {
      /** The model output could not be validated. Never silent: the family gets a heads-up. */
      readonly ok: false;
      readonly level: 'attention';
      readonly error: string;
    };

/** Full pipeline for one call: raw model output → validated facts → triage → alert level. */
export function assessCall(
  rawExtraction: unknown,
  transcript: Transcript,
  history: readonly DayFacts[] = [],
): Assessment {
  const parsed = CallExtractionSchema.safeParse(rawExtraction);
  if (!parsed.success) {
    return { ok: false, level: 'attention', error: parsed.error.message };
  }
  const triage = triageMentions(parsed.data.mentions, parentSpeech(transcript));
  const facts = toDayFacts(parsed.data, triage);
  return {
    ok: true,
    level: alertLevel(facts, history),
    facts,
    extraction: parsed.data,
    dropped: triage.dropped,
  };
}
